import _ from 'lodash';
import React, { useMemo } from 'react';
import {
  ProjectTaskFilter,
  ProjectTaskRecordStatusFilter,
  ProjectTaskStatusFilter,
  ProjectTaskTagFilter,
} from '~/components';
import ReportPeriodFilter from '~/components/filters/ReportPeriodFilter';

export default function TaskFiltersBar({ filters, sticky, onChange }) {
  const visible = useMemo(() => {
    const isVisible = (key) => sticky?.includes(key) || !_.isEmpty(filters[key]);
    const isPeriodVisible = (key) => sticky?.includes(key) || filters[key]?.start || filters[key]?.end;
    return {
      projectTasks: isVisible('projectTasks'),
      projectTaskStatuses: isVisible('projectTaskStatuses'),
      projectTaskRecordStatusId: isVisible('projectTaskRecordStatusId'),
      projectTaskTags: isVisible('projectTaskTags'),
      projectTaskStartDatePeriod: isPeriodVisible('projectTaskStartDatePeriod'),
      projectTaskEndDatePeriod: isPeriodVisible('projectTaskEndDatePeriod'),
    };
  }, [filters, sticky]);

  return (
    <>
      {visible.projectTasks && (
        <ProjectTaskFilter
          project={filters.projects[0]}
          value={filters.projectTasks}
          onChange={({ value }) => onChange({ projectTasks: value })}
        />
      )}

      {visible.projectTaskStatuses && (
        <ProjectTaskStatusFilter
          value={filters.projectTaskStatuses}
          onChange={({ value }) => onChange({ projectTaskStatuses: value })}
        />
      )}

      {visible.projectTaskRecordStatusId && (
        <ProjectTaskRecordStatusFilter
          value={filters.projectTaskRecordStatusId}
          onChange={({ value }) => onChange({ projectTaskRecordStatusId: value })}
        />
      )}

      {visible.projectTaskTags && (
        <ProjectTaskTagFilter
          value={filters.projectTaskTags}
          onChange={({ value }) => onChange({ projectTaskTags: value })}
        />
      )}

      {visible.projectTaskStartDatePeriod && (
        <div data-testid="task-start-date-filter">
          <ReportPeriodFilter
            placeholder="Task Start Date"
            value={filters.projectTaskStartDatePeriod}
            onChange={({ target: { value } }) => onChange({ projectTaskStartDatePeriod: value })}
          />
        </div>
      )}

      {visible.projectTaskEndDatePeriod && (
        <div data-testid="task-end-date-filter">
          <ReportPeriodFilter
            placeholder="Task End Date"
            value={filters.projectTaskEndDatePeriod}
            onChange={({ target: { value } }) => onChange({ projectTaskEndDatePeriod: value })}
          />
        </div>
      )}
    </>
  );
}
